import { Button, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"
import { create } from "zustand"

import { useConfirmRedeemChildRewardModalStore } from "./ConfirmRedeemChildRewardModal"
import { CloseButton } from "../../../components/closeButton/CloseButton"
import SlideUpModal from "../../../components/slideUpModal/SlideUpModal"

interface useRedeemChildRewardModalStoreProps {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

export const useRedeemChildRewardModalStore =
  create<useRedeemChildRewardModalStoreProps>((set) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => set({ isOpen: false }),
  }))

const RedeemChildRewardModal = () => {
  const { isOpen, onClose } = useRedeemChildRewardModalStore()
  const { onOpen: onOpenConfirmRedeemChildRewardModal } =
    useConfirmRedeemChildRewardModalStore()
  const { t } = useTranslation()

  const onRedeem = () => {
    onOpenConfirmRedeemChildRewardModal()
    onClose()
  }

  return (
    <SlideUpModal
      isOpen={isOpen}
      onClose={onClose}
      size="fit-content"
      backgroundType="overlay"
    >
      <CloseButton onClick={onClose} />
      <div className="flex flex-col p-4 gap-6">
        <Typography variant="h4">{t("CT_REDEEM_TITLE")}</Typography>
        <Typography variant="bodySmall">{t("CT_REDEEM_DESC")}</Typography>
        <div className="flex gap-2">
          <Button
            buttonType="secondary"
            fullWidth
            text={t("QB_CANCEL")}
            onClick={onClose}
          />
          <Button
            buttonType="primary"
            fullWidth
            text={t("CT_REDEEM")}
            onClick={onRedeem}
          />
        </div>
      </div>
    </SlideUpModal>
  )
}

export default RedeemChildRewardModal
